//PrisutstvuyushchieNaZasedaniiPravleniyaFederatsii
import React, { } from 'react';
import { Form, Input } from 'antd';





export default function TantsoriFederatsiiFilter(props) {    
    return (
        <Form
            form={props.form}
            labelAlign={"left"}
            layout={"vertical"}
        >
            <Form.Item
                name={"Email"}
                label={"Email"}
                rules={[{ required: false, message: 'Укажите Email!' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={"Lastname"}
                label={"Фамилия"}
                rules={[{ required: false, message: 'Укажите фамилию!' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={"Firstname"}
                label={"Имя"}
                rules={[{ required: false, message: 'Укажите имя!' }]}
            >
                <Input />
            </Form.Item>
        </Form>
    );
}
